import { 
    FORCE_IS_ACTIVE_SESSION,
    ALTER_DISABLED_STATUS_OF_INPUTBOX,
    } from './actionTypes';

export function forceIsActiveSession(input: boolean, stateLocation: string): {type: string; payload: { input: boolean; stateLocation: string}}
{
    return {
        type: FORCE_IS_ACTIVE_SESSION,
        payload: {
            input,
            stateLocation,
        },
    };
}

export function alterInputBoxDisabledStatus(payload: unknown): {type: string; payload: unknown}{
    return {
        type : ALTER_DISABLED_STATUS_OF_INPUTBOX,
        payload,
    };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/appevent-welcomeuser-onlaunch/src/actions/actions.ts